// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design System · Tokens · Construction OS Platform (blue + lime · FUTURE)
 * V3 §1B deferred. Not applied to any production route today.
 */
.ds-theme-platform {
  --color-canvas: #0B1220;
  --color-surface: #142136;
  --color-surface-2: #1E304C;
  --color-primary: #2563EB;
  --color-primary-emphasis: #3B82F6;
  --color-accent: #A3E635;
  --color-text: #F1F5F9;
  --color-text-muted: #94A3B8;
  --color-border: #334155;
  --color-status-positive: #22C55E;
  --color-status-warning: #F59E0B;
  --color-status-danger: #F87171;
  --color-status-info: #60A5FA;
  --color-status-superseded: #A78BFA;
  --font-display: "Space Grotesk", "Inter Tight", sans-serif;
  --font-body: "Inter Tight", "Inter", system-ui, sans-serif;
  --font-mono: "JetBrains Mono", "IBM Plex Mono", monospace;
  --radius-sm: 4px;
  --radius: 8px;
  --radius-lg: 12px;
  color-scheme: dark;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/tokens/platform.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,0DAA0D;EAC1D,0DAA0D;EAC1D,yDAAyD;EACzD,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Design System · Tokens · Construction OS Platform (blue + lime · FUTURE)\n * V3 §1B deferred. Not applied to any production route today.\n */\n.ds-theme-platform {\n  --color-canvas: #0B1220;\n  --color-surface: #142136;\n  --color-surface-2: #1E304C;\n  --color-primary: #2563EB;\n  --color-primary-emphasis: #3B82F6;\n  --color-accent: #A3E635;\n  --color-text: #F1F5F9;\n  --color-text-muted: #94A3B8;\n  --color-border: #334155;\n  --color-status-positive: #22C55E;\n  --color-status-warning: #F59E0B;\n  --color-status-danger: #F87171;\n  --color-status-info: #60A5FA;\n  --color-status-superseded: #A78BFA;\n  --font-display: \"Space Grotesk\", \"Inter Tight\", sans-serif;\n  --font-body: \"Inter Tight\", \"Inter\", system-ui, sans-serif;\n  --font-mono: \"JetBrains Mono\", \"IBM Plex Mono\", monospace;\n  --radius-sm: 4px;\n  --radius: 8px;\n  --radius-lg: 12px;\n  color-scheme: dark;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
